import { render, staticRenderFns } from "./UserProfileSurgeons.vue?vue&type=template&id=7066cf00"
import script from "./UserProfileSurgeons.vue?vue&type=script&lang=js"
export * from "./UserProfileSurgeons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports